<script>
import Multiselect from "vue-multiselect"

const DEFAULT_EMPTY_TEXT = "Data tidak ditemukan."

export default {
    name: "multiselect-default",
    inheritAttrs: false,
    render(h) {
        const scopedSlots = { ...this.$scopedSlots }
        if (!scopedSlots.noResult) scopedSlots.noResult = () => DEFAULT_EMPTY_TEXT
        if (!scopedSlots.noOptions) scopedSlots.noOptions = () => DEFAULT_EMPTY_TEXT

        return h(Multiselect, {
            attrs: this.$attrs,
            on: this.$listeners,
            scopedSlots,
        })
    },
}
</script>
